import { render, staticRenderFns } from "./ParticipantCasualtyAppraiser.vue?vue&type=template&id=54b34ae9"
import script from "./ParticipantCasualtyAppraiser.vue?vue&type=script&lang=js"
export * from "./ParticipantCasualtyAppraiser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports